module.exports = __webpack_public_path__ + "static/media/Antonia Burrell, Celebrity Facialist.74f8c418.png";